<template>
    <div class="main-section">
        <PageLoader v-if="processing"/>
        <section v-if="showForm">
            <ValidationObserver ref="form">
                <div class="title" :class="[{'has-margin-bottom-15': hasError && showErrors}]">{{ headerTitle }}</div>

                <div class="field form-row" v-if="hasError && showErrors">
                    <div class="text text-red error-message">Oops! That email / password combination is not valid</div>
                </div>
                <ValidationProvider name="token" v-slot="{ errors }">
                    <div class="is-invalid invalid-message" v-if="errors[0]">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider name="email" v-slot="{ errors }" v-if="step === 'password-reset'">
                    <div class="is-invalid invalid-message" v-if="errors[0]">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider name="email"
                                    rules="required|email"
                                    v-slot="{ errors }"
                                    mode="eager"
                                    v-if="step !== 'password-reset'">
                    <b-field class="has-margin-top-30 input-wrap" :class="[{'is-invalid': errors[0]}]">
                        <label :class="[{'show': (formData.email) ? formData.email.length > 0 : ''}]">Email</label>
                        <b-input type="text"
                                 :class="[{'is-invalid': errors[0]}]"
                                 @keyup.native.enter="register"
                                 placeholder="Email"
                                 v-model="formData.email">
                        </b-input>
                        <div class="is-invalid invalid-message" v-if="errors[0]">{{ errors[0] }}</div>
                    </b-field>
                </ValidationProvider>

                <div v-if="step !== 'forgot-password'">
                    <ValidationProvider name="password"
                                        rules="required|min:8"
                                        v-slot="{ errors }"
                                        mode="eager">
                        <b-field v-show="!showPassword" class="input-wrap password-wrap" :class="[{'is-invalid': errors[0]}]">
                            <label :class="[{'show': formData.password.length > 0}]">Password</label>
                            <b-input type="password"
                                     :class="[{'is-invalid': errors[0]}]"
                                     :placeholder="$t('password')"
                                     @keyup.native.enter="register"
                                     v-model="formData.password">
                            </b-input>
                            <div class="is-invalid invalid-message" v-if="errors[0]">{{ errors[0] }}</div>
                        </b-field>
                        <b-field v-show="showPassword" class="input-wrap">
                            <b-input type="text"
                                     :class="[{'is-invalid': errors[0]}]"
                                     :placeholder="$t('password')"
                                     @keyup.native.enter="register"
                                     v-model="formData.password">
                            </b-input>
                        </b-field>
                    </ValidationProvider>
                    <ValidationProvider name="password_confirmation"
                                        rules="required|min:8"
                                        mode="eager"
                                        v-slot="{ errors }"
                                        v-if="step === 'password-reset'">
                        <b-input type="password"
                                 class="has-margin-bottom-15"
                                 :class="[{'is-invalid': errors[0]}]"
                                 @keyup.native.enter="register"
                                 placeholder="Enter your password confirmation"
                                 v-model="formData.password_confirmation">
                        </b-input>
                        <div class="is-invalid invalid-message" v-if="errors[0]">{{ errors[0].replace('_', ' ') }}</div>
                    </ValidationProvider>

                </div>

                <div class="field form-row has-margin-bottom-30" v-if="!step.includes('password')">
                    <!-- <label class="b-checkbox checkbox remember-checkbox text">
                        <input type="checkbox" value="false" v-model="formData.remember">
                        <span class="check is-danger"></span>
                        <span class="control-label text-white">{{ $t('remember_me') }}</span>
                    </label> -->
                    <span @click="changeInputType" class="show-password text text-white has-cursor-pointer">
                        {{showPassword ? 'Hide' : 'Show'}} {{ $t('password') }}
                    </span>
                </div>

                <div class="field form-row has-margin-top-62 has-margin-bottom-none">
                    <b-button type="is-danger" expanded @click="register" :disabled="disableMainBtn">{{ buttonTitle }}
                    </b-button>
                </div>

                <div class="field form-row has-margin-bottom-30" v-if="showForgotPassword">
                    <router-link :to="{name: 'forgot-password'}" class="text text-bold text-white text-big">{{ $t('forgot_password') }}
                    </router-link>
                </div>

                <div class="field form-row is-left has-margin-top-62" v-if="step === 'sign-up'">
                    <router-link :to="{name: 'sign-in'}" class="text text-white">{{ $t('already_have_account') }}</router-link>
                </div>

                <!-- <div class="field form-row is-left has-margin-bottom-7" v-if="step === 'sign-in'">
                    <router-link :to="{name: 'sign-up'}" class="text text-white">{{ $t('no_account') }}</router-link>
                </div> -->

                <!-- <div class="field form-row is-left">
                    <span class="text">Need help or have a question, <a :href='mailto'
                                                                        class="text text-green">get in touch</a>.</span>
                </div> -->
            </ValidationObserver>
        </section>
        <section v-if="step === 'sign-up-success'" class="success-section">
            <div class="section-content">
                <div class="title is-bottom-marginless">Success</div>
                <div class="heading--auth__h4 has-margin-top-25">
                    {{ successMessage }}
                </div>
            </div>
            <div class="field form-row has-margin-bottom-30 section-footer">
                <b-button type="is-danger" expanded @click="logout">Login
                </b-button>
            </div>
        </section>
    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from 'vee-validate/dist/vee-validate.full';
    import PageLoader from "@/components/PageLoader";

    export default {
        name: "SignInForm",
        props: {
            mode: {
                type: String,
                default: 'sign-up',
            },
            headerTitle: {
                type: String,
                default: 'Create an account',
            },
            buttonTitle: {
                type: String,
                default: 'Register',
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            showForgotPassword: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            ValidationProvider, ValidationObserver, PageLoader
        },
        mounted() {
            this.formData.token = this.$route.query && this.$route.query.token;
            this.formData.email = this.$route.query && this.$route.query.email;

            /* if (this.formData.email) {
                this.formData.email = this.formData.email.replace(" ", "+");
            } */
            if (this.isAuthenticated) {
                this.processing = true;
                this.$store.dispatch('getSelf').finally(() => {
                    if (this.user && this.user.email !== this.formData.email) {
                        this.$store.dispatch('logout');
                    } else {
                        if (this.user && this.user.is_active) {
                            this.$router.push({name: 'get-started'});
                        } else {
                            this.step = 'sign-up-success';
                        }
                    }
                    this.processing = false;
                })
            }


        },
        computed: {
            successMessage() {
                return this.$route.name === 'password-reset' ? 'You successfully reset your password.' : 'We have sent you an activation code, please check your email.';
            },
            user() {
                return this.$store.state.auth.user;
            },
            isAuthenticated() {
                return !!this.$store.state.auth.accessToken;
            },
            showForm() {
                return ['sign-in', 'sign-up', 'forgot-password', 'password-reset'].includes(this.step);
            },
            disableMainBtn() {
                switch (this.$route.name) {
                    case 'sign-in':
                    case 'sign-up':
                    default:
                        return !this.formData.email || !this.formData.password;
                    case 'forgot-password':
                        return !this.formData.email;
                    case 'password-reset':
                        return !this.formData.password || !this.formData.password_confirmation
                            || (this.formData.password !== this.formData.password_confirmation)
                }
            },

            mailto() {
                return `mailto:${process.env.VUE_APP_CONTACT_MAIL}`;
            }
        },
        data() {
            return {
                formData: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                    remember: false,
                    token: '',
                },
                step: this.mode,
                showPassword: false,
                hasError: false,
                processing: false,
            }
        },
        methods: {
            changeInputType() {
                this.showPassword = !this.showPassword;
            },

            register() {
                let actionName = '';
                let formData = this.formData;
                switch (this.$route.name) {
                    case 'sign-in':
                    default:
                        actionName = 'login';
                        break;
                    case 'sign-up':
                        actionName = 'register';
                        break;
                    case 'forgot-password':
                        actionName = 'forgotPassword';
                        break;
                    case 'password-reset':
                        actionName = 'passwordReset';
                        this._lodash.assign(formData, {
                            token: this.$route.params && this.$route.params.token,
                            email: this.$route.query && this.$route.query.email,
                        });
                        break;
                }

                this.processing = true;
                this.$store.dispatch(actionName, formData).then(() => {
                    if (['forgotPassword', 'passwordReset'].includes(actionName)) {
                        this.step = 'sign-up-success';
                    } else if (actionName === 'login'
                        && this.$route.params && this.$route.params.verifyData) {
                        this.$store.dispatch('verifyEmail',
                            this.$route.params.verifyData).finally(() => {
                            this.$router.push('/get-started');
                        })
                    } else {
                        this.$store.dispatch('getSelf').then(() => {
                            if (this.user && this.user.is_active) {
                                this.$router.push({name: 'get-started'});
                            } else {
                                this.step = 'sign-up-success';
                            }
                        });
                    }

                }).catch((errors) => {
                    this._lodash.forEach(errors, (value, key) => {
                        if (this.$refs.form.errors && this.$refs.form.errors[key]) {
                            if (key === 'token' && this.mode === 'sign-up' && !this.$route.params.token) {
                                this.$refs.form.errors[key].push('You need to use the link in your invitation email');
                            } else {
                                this.$refs.form.errors[key].push(value && value[0]);
                            }
                        }
                    })
                }).finally(() => {
                    this.processing = false;
                })
            },
            logout() {
                this.processing = true;
                this.$store.dispatch('logout').finally(() => {
                    if (this.$route.path !== '/sign-in') {
                        this.$router.push('/sign-in')
                    } else {
                        this.$router.go()
                    }
                    this.processing = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
